import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { ReactComponent as ThumbUp } from 'style/icons/thumb_up.svg';
import Label from 'components/form/Label/Label';
import './RewardAndBonusOffer.scss';

export const RewardAndBonusOffer = props => {
  const { offerMetadata } = props;

  return (
    <FlexContainer className="RewardAndBonusOffer flex-column align-items-start width100 gap-8 d-hide">
      <FlexContainer className="bonusOfferCard width100">
        <FlexContainer className="align-items-center justify-between gap-12">
          <ThumbUp width={24} height={24} />
          <Label
            className="bonusOfferNameColor lineHeight18 fontLatoNormal700 text-12"
            dangerouslySetInnerHTML={{
              __html: offerMetadata?.bonusOfferInfo?.bonusOfferName,
            }}
          />
        </FlexContainer>
      </FlexContainer>
      <FlexContainer className={`flex-column NativeAd padL10 width100`}>
        <Label
          className="Body-2 t-text-12 bullets-ad system_neutral_n400_text"
          dangerouslySetInnerHTML={{
            __html: offerMetadata?.bonusOfferInfo?.bonusOfferBulletsText,
          }}
        />
      </FlexContainer>
    </FlexContainer>
  );
};
